import React from 'react';

export default tickers => (dispatch, getState) => {

  dispatch({ type: 'LOADING_TYPEAHEAD' });

  const { token, entry, complianceText, wtRegion } = getState();

  const addFunds = foundResults => {
    dispatch({ type: 'ADD_FUNDS', funds: foundResults, side: entry.inFocus });
  }

  const requestBody = {
    tickers: tickers,
    wtRegion: wtRegion,
  }

  fetch(`${process.env.REACT_APP_API_URL}/securityfund/ticker_names/`, {
    method: 'POST',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json',
      Authorization: token &&
        `Token ${token}`,
    },
  })
    .then(d => d.json())
    .then(data => {

      dispatch({ type: 'LOADED_TYPEAHEAD' });

      let results = [[], []]; //[not found, found]
      data.tickers.forEach((ticker,i,a) => {
        const row = {
          ticker: ticker.replace("ZZZ", "(empty)"),
          name: data.names[i],
          type: data.types[i],
          weight: 1e6 / a.length
        }
        results[+(row.name !== "UNKNOWN")].push(row);
      })

      const messageNotFound = results[0].length
        ? (<div>
          {complianceText.tickersNotRecognizedUpload}
          <span className="error-red"> {results[0].map(o => o.ticker).join(", ")}</span>
        </div>)
        : '';

      if(messageNotFound){
        dispatch({
          type: 'DIALOG',
          message: <div>{messageNotFound}</div>,
          buttons: [
            { label: 'Cancel' },
            { label: 'Continue', callback: () => {
              addFunds(results[1])
            }},
          ],
        })
      } else {      
        addFunds(results[1])
      }
    })
    .catch(error => {
      console.error(error);
    });
};


// WEBPACK FOOTER //
// ./src/actions/query-api/ticker-names-partial.js